import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  listNodeDefinitions,
  type NodeDefinitionDto,
} from '@api/nodeDefinitions';

export const nodeDefinitionsQueryKey = ['processes', 'node-definitions'] as const;

/**
 * Never refetched on its own: built-in definitions only change on a redeploy.
 * The org's shared custom skills in the Task skill dropdown can change at any
 * time, so the Skills page invalidates this key whenever one is saved or deleted.
 */
export function useNodeDefinitions(
  enabled: boolean = true,
): UseQueryResult<readonly NodeDefinitionDto[], Error> {
  return useQuery<readonly NodeDefinitionDto[], Error>({
    queryKey: nodeDefinitionsQueryKey,
    queryFn: () => listNodeDefinitions(),
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
